import React from 'react';
import { Button, IconButton, useMediaQuery, useDisclosure } from '@chakra-ui/react';
import { useSelector } from 'react-redux';

import { getIsPageBarOpen } from 'redux/DashboardSliceV2';
import DownloadIcon from 'components/Icons/DownloadIcon';

import PreviewModal from './PreviewModal';

const ExportButtonNew = () => {
  const isPageBarOpen = useSelector(getIsPageBarOpen);
  const [smallDevice] = useMediaQuery('(max-width: 1100px)');
  const isSmallDevice = (smallDevice && isPageBarOpen) || smallDevice;
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <>
      {isSmallDevice ? (
        <IconButton
          aria-label='Export'
          icon={<DownloadIcon />}
          backgroundColor='#5A58AB'
          borderRadius='sm'
          height='40px'
          border='none'
          fontSize='md'
          fontWeight='400'
          width='fit-content'
          title='Export'
          padding='.5rem 1rem'
          color='white'
          onClick={onOpen}
        />
      ) : (
        <Button
          backgroundColor='#5A58AB'
          borderRadius='sm'
          height='40px'
          leftIcon={<DownloadIcon />}
          fontSize='md'
          border='none'
          fontWeight='400'
          width='fit-content'
          title='Export'
          padding='.5rem 1rem'
          color='white'
          onClick={onOpen}
        >
          Export
        </Button>
      )}

      <PreviewModal isOpen={isOpen} onClose={onClose} selectedPages={[]} />
    </>
  );
};

export default ExportButtonNew;
